import { createFileRoute } from "@tanstack/react-router"
import { BillingPage } from "@/components/BillingPage"

// Auth gating lives in the `_authenticated` parent component.
export const Route = createFileRoute(`/_authenticated/billing`)({
  component: Billing,
  ssr: false,
})

function Billing() {
  return <BillingPage />
}
